import { Form, Formik } from 'formik';
import React from 'react';
import ModalComponent from '../../../components/modal/modal';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import InputText from '../../../components/input-text/inputText';
import FormSelect from '../../../components/dropdown/formSelect';
import {
  useGetGrantAcceptanceTemplateStatus,
  usePostGrantAcceptanceTemplateNameAndStatus,
  useWealthlaneAwardApi,
} from '../../../hooks';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import _ from 'lodash';

interface EditTemplateNameStatusProps {
  isModalOpen: boolean;
  closeModal: () => void;
  loading: boolean;
  initialData: any;
}

const EditTemplateNameStatus = ({
  isModalOpen,
  closeModal,
  loading,
  initialData,
}: EditTemplateNameStatusProps) => {
  const { handleRequest } = useWealthlaneAwardApi();
  const { data: GrantAcceptanceTemplateStatus, isLoading: isGrantAcceptanceTemplateStatusLoading } =
    useGetGrantAcceptanceTemplateStatus(handleRequest);
  const { mutate, isLoading } = usePostGrantAcceptanceTemplateNameAndStatus(
    handleRequest,
    closeModal
  );

  const handleSubmit = (values: any) => {
    mutate(values);
  };
  return (
    <Formik
      enableReinitialize
      initialValues={initialData}
      // validationSchema={PARTICIPANT_BROADCAST_MESSAGE_VALIDATION}
      onSubmit={(values) => {
        handleSubmit(values);
      }}>
      {({ touched, handleChange, errors, setFieldValue, setFieldTouched, values }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={loading}
            size='sm'
            title={`Edit Template Name and Status`}
            valueEdited={_.isEqual(values, initialData)}
            children={
              <Form>
                <ModalBodyComponent>
                  <InputText
                    type='text'
                    label='Template Name'
                    name='templateName'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    inputType={initialData.modalStatus}
                    disabled={initialData.modalStatus === 'View'}
                    required
                    id='templateNameInput'
                  />
                  <FormSelect
                    label='Status'
                    name='statusId'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    options={GrantAcceptanceTemplateStatus}
                    values={values}
                    setFieldValue={setFieldValue}
                    disabled={initialData.modalStatus === 'View'}
                    required
                    isLoading={isGrantAcceptanceTemplateStatusLoading}
                    id='statusIdInput'
                  />
                </ModalBodyComponent>
                <ModalFooterComponent
                  id='editTemplateNameStatusModalFooter'
                  loading={isLoading}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  modalStatus='Edit'
                  valueChanged={_.isEqual(values, initialData)}
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default EditTemplateNameStatus;
